(function () {
  const embedEl = document.getElementById("menu-images-embed");
  if (!embedEl) return;

  let config;
  try {
    config = JSON.parse(embedEl.textContent);
  } catch (e) {
    console.error("[menu-images] JSON invalide :", e);
    return;
  }

  const normalizeLabel = (str) => {
    return String(str || "")
      .toLowerCase()
      .normalize("NFD") // sépare les accents
      .replace(/[\u0300-\u036f]/g, "") // enlève les accents
      .replace(/[\u2010-\u2015]/g, "-") // tous les tirets fancy → "-"
      .replace(/\s+/g, " ") // espaces multiples → 1 espace
      .trim();
  };

  const menus = (config.menus || []).map((menu) => {
    const raw = String(menu.label || "");
    const keys = raw.split("|").map((k) => normalizeLabel(k));
    return Object.assign({}, menu, { _keys: keys });
  });

  if (!menus.length) return;

  const menuSelector = config.menu_selector || "header details.mega-menu";
  const menuNodes = document.querySelectorAll(menuSelector);
  if (!menuNodes.length) return;

  const submenuSelectorRaw =
    config.submenu_selector || "details.mega-menu > .mega-menu__content";
  const insertionPosition =
    config.insertion_position === "start" ? "start" : "end";

  menuNodes.forEach((detailsEl) => {
    // on récupère le label visible du menu
    const labelEl =
      detailsEl.querySelector("summary") ||
      detailsEl.querySelector("button") ||
      detailsEl.querySelector("a") ||
      detailsEl.querySelector("span");

    if (!labelEl) return;

    const domLabelNorm = normalizeLabel(labelEl.textContent || "");

    const matched = menus.find((m) => m._keys.includes(domLabelNorm));
    if (!matched) return;

    const imageConfig = (matched.images || [])[0];
    if (!imageConfig || !imageConfig.image) return;

    // trouver le panneau submenu dans CE details
    let submenuEl = null;
    try {
      if (submenuSelectorRaw.includes(">")) {
        const subSel = submenuSelectorRaw.split(">").pop().trim();
        submenuEl = detailsEl.querySelector(subSel);
      } else {
        submenuEl =
          detailsEl.querySelector(submenuSelectorRaw) ||
          detailsEl.querySelector(".mega-menu__content");
      }
    } catch (e) {
      submenuEl = detailsEl.querySelector(".mega-menu__content");
    }

    if (!submenuEl) return;

    // éviter les doublons si déjà injecté
    if (submenuEl.querySelector(".mmx-image-col")) return;

    // créer la colonne image
    const col = document.createElement("div");
    col.className = "mmx-image-col";

    if (imageConfig.column_width) {
      col.style.setProperty(
        "--mmx-col-width",
        parseInt(imageConfig.column_width, 10) + "px"
      );
    }
    if (imageConfig.margin_right !== undefined && imageConfig.margin_right !== null) {
      col.style.setProperty(
        "--mmx-mr",
        parseInt(imageConfig.margin_right, 10) + "px"
      );
    }

    const hasLink = !!imageConfig.href;
    const banner = document.createElement(hasLink ? "a" : "div");
    banner.className = "mmx-banner";
    if (hasLink) {
      banner.href = imageConfig.href;
    }

    const img = document.createElement("img");
    img.className = "mmx-banner__img";
    img.src = imageConfig.image;
    img.alt = imageConfig.alt || "";


    // format → aspect-ratio
    let ratio = null;
    switch (imageConfig.image_format) {
      case "landscape":
        ratio = "16 / 9";
        break;
      case "portrait":
        ratio = "2.5 / 3.5";
        break;
      case "square":
        ratio = "1 / 1";
        break;
      default:
        ratio = null;
    }
    if (ratio) {
      img.style.aspectRatio = ratio;
    }

    // taille / hauteur
    if (imageConfig.image_size === "custom" && imageConfig.custom_height) {
      img.style.height = parseInt(imageConfig.custom_height, 10) + "px";
      img.style.objectFit = "cover";
    }

    if (imageConfig.border_radius) {
      img.style.borderRadius =
        parseInt(imageConfig.border_radius, 10) + "px";
    }

    if (imageConfig.shadow && imageConfig.shadow !== "none") {
      const shadow =
        imageConfig.shadow === "soft"
          ? "0 8px 24px rgba(0,0,0,.18)"
          : "0 12px 32px rgba(0,0,0,.28)";
      img.style.boxShadow = shadow;
    }

    if (imageConfig.border && imageConfig.border !== "none") {
      const w = imageConfig.border === "thin" ? 1 : 2;
      img.style.border = w + "px solid rgba(0,0,0,.12)";
    }

    banner.appendChild(img);

    if (imageConfig.title) {
      const title = document.createElement("div");
      title.className = "mmx-banner__title";
      title.textContent = imageConfig.title;

    title.dataset.titleSize = imageConfig.title_size || "medium";
title.dataset.titlePosition = imageConfig.title_position || "center";


      switch (imageConfig.title_position) {
        case "top":
          title.style.alignItems = "flex-start";
          break;
        case "bottom":
          title.style.alignItems = "flex-end";
          break;
        default:
          title.style.alignItems = "center";
      }

      if (imageConfig.overlay) {
        title.style.background = "rgba(0,0,0,.35)";
      } else {
        title.style.background = "transparent";
        title.style.textShadow = "0 1px 3px rgba(0,0,0,.55)";
      }

      banner.appendChild(title);
    }

    col.appendChild(banner);

    if (insertionPosition === "start") {
      submenuEl.insertBefore(col, submenuEl.firstChild);
    } else {
      submenuEl.appendChild(col);
    }
  });
})();
